import { FormularioInformeDividendoRecaudadoModel } from "../models/formularioInformeDividendoRecaudadoModel"
import { useEffect } from "react";
import { selectorTransversal } from "../../../../dtos/selector";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from "react-hook-form";
import { Grid2 } from "@mui/material";
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import InputFecha from '../../../../components/inputs/yup/materialui/inputFecha';
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { FilterList } from "@mui/icons-material";
import UseEndosoMasivo from "../../../endosos/endososMasivos/hooks/useEndosoMasivo";
import { FormularioInformeDividendoNoRecaudadoModel } from "../models/formularioInformeDividendoNoRecaudadoModel";
import InputSwitch from "../../../../components/inputs/yup/materialui/inputSwitch";

interface IProps {
    onSubmit: (e: FormularioInformeDividendoNoRecaudadoModel) => void;
}

export const FormularioInformeDividendoNoRecaudado : React.FC<IProps> = ({onSubmit}) => {

    const selectorTipo : selectorTransversal[] = [
        {label: "Propios", value: "P"},
        {label: "Garantizado", value: "G"},
        {label: "No garantizado", value: "NG"},     
    ];

    const selectorTipoReporte : selectorTransversal[] = [
        {label: "XLSX", value: "XLSX"},
        {label: "PDF", value: "PDF"}
    ];

    const { inversionistas, getInversionistas } = UseEndosoMasivo();

    const validationSchema = Yup.object<FormularioInformeDividendoNoRecaudadoModel>().shape({
        desdeHistorico: Yup.boolean().optional(),
        fechaEmision: Yup.date().required("Campo requerido"),
        fechaDesde: Yup.date().required("Campo requerido").test("isValiDate", "Debe ser anterior a la de término", (value) => isValidDate(value)),
        fechaHasta: Yup.date().required("Campo requerido"),
        tipo: Yup.string().nullable().optional(),
        rutInversionista: Yup.string().nullable().optional(),
        tipoReporte: Yup.string().required("Campo requerido"),
    });

    const hoy = new Date(); 
    const year = hoy.getFullYear();
    const month = hoy.getMonth();
    const day = hoy.getDate();
    const ultimoDiaMesAnterior = new Date(year, month, 0).getDate();
    const mesPasado = new Date(year, month - 1, Math.min(day, ultimoDiaMesAnterior));

    const defaultValues : FormularioInformeDividendoNoRecaudadoModel = {
        desdeHistorico: false,
        fechaEmision: hoy,
        fechaDesde: mesPasado,
        fechaHasta: hoy,
        tipoReporte: "XLSX"
    }

    const {
        control,
        formState: { errors, isDirty },
        reset,
        watch,
        handleSubmit,
        setError,
        setValue,
        trigger
    } = useForm<FormularioInformeDividendoNoRecaudadoModel>({
        resolver: yupResolver(validationSchema),
        mode: 'onChange',
        defaultValues: defaultValues
    });

    const watcher = watch();
    
    useEffect(() => {
        reset(defaultValues);
        getInversionistas();
    }, [])

    useEffect(() => {
        trigger("fechaDesde")
    }, [watcher.fechaHasta])

    const isValidDate = (e: Date) : boolean => {
        const fechaDesdeFormated = new Date(e).setHours(0, 0, 0);
        const fechaHastaFormated = new Date(watcher.fechaHasta).setHours(0, 0, 0);
        return fechaDesdeFormated <= fechaHastaFormated;
    }

    return(
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputSwitch
                        disabled
                        name="desdeHistorico"
                        control={control}
                        label="Desde histórico"
                        error={errors.desdeHistorico}
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputFecha
                        label="Fecha emisión (*)"
                        name="fechaEmision"
                        control={control}
                        fecha={watcher.fechaEmision}
                        error={errors.fechaEmision}
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputFecha
                        label="Fecha desde (*)"
                        name="fechaDesde"
                        control={control}
                        fecha={watcher.fechaDesde}
                        error={errors.fechaDesde}
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputFecha
                        label="Fecha hasta (*)"
                        name="fechaHasta"
                        control={control}
                        fecha={watcher.fechaHasta}
                        error={errors.fechaHasta}
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputSelect
                        label="Tipo"
                        name={'tipo'}
                        control={control}
                        options={selectorTipo}
                        error={errors.tipo}
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputSelect
                        label="Inversionista"
                        name={'rutInversionista'}
                        control={control}
                        options={inversionistas}
                        error={errors.rutInversionista}
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputSelect
                        label="Tipo reporte"
                        name={'tipoReporte'}
                        control={control}
                        options={selectorTipoReporte}
                        error={errors.tipoReporte}
                        disabled
                        readonly
                    />
                </Grid2>
            </Grid2>
            <Grid2 size={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                <MButton type="submit" variant="contained" color="primary" startIcon={<FilterList />}>
                    Generar
                </MButton>
            </Grid2>
        </form>
    )
}